var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20.9999V18.9999H21V20.9999H3ZM4.85 15.9999L2 11.1499L3.55 10.8499L5.3 12.3999L10.1 11.0999L6.05 4.2499L8 3.6499L14.85 9.7999L19.85 8.4499C20.3833 8.2999 20.8667 8.3999 21.3 8.7499C21.7333 9.0999 21.95 9.56657 21.95 10.1499C21.95 10.5166 21.8375 10.8416 21.6125 11.1249C21.3875 11.4082 21.1 11.5999 20.75 11.6999L4.85 15.9999Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.a84418d3.svg";
export { ForwardRef as ReactComponent };